"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StylesPathBuilder_1 = require("./StylesPathBuilder");
var StylesInjector = /** @class */ (function () {
    function StylesInjector(stylesInjector, stylesPathBuilder) {
        this.stylesInjector = stylesInjector;
        this.stylesPathBuilder = stylesPathBuilder;
        this.stylesPathBuilder = this.stylesPathBuilder !== undefined && this.stylesPathBuilder !== null
            ? this.stylesPathBuilder
            : new StylesPathBuilder_1.StylesPathBuilder();
    }
    StylesInjector.prototype.inject = function (modLoader, stylesConfig) {
        var _this = this;
        var stylesList = this.stylesPathBuilder.build(stylesConfig);
        stylesList.forEach(function (style) {
            _this.stylesInjector.inject(style);
        });
    };
    return StylesInjector;
}());
exports.StylesInjector = StylesInjector;
//# sourceMappingURL=StylesInjector.js.map